import {
  generateNode,
  insertAfterNodeByUIDAtSectionLevel,
} from "../doc_helpers";

export function handleNewMediaInsert<DocContent extends PossibleContent>(
  mediaType: MediaType,
  currentDocument: CurrentDocument,
  modifyContent: (modifyFunction: ModifyFunction<DocContent>) => void,
  setCurrentlyEditing: (currentlyEditing: CurrentlyEditing | undefined) => void,
  currentlyEditingOverride?: CurrentlyEditing,
) {
  if (currentDocument.type === "Activity") { return; }

  let newUid: string | undefined;
  modifyContent((json, currentlyEditing) => {
    const currentSelection = currentlyEditingOverride || currentlyEditing;
    if (!currentSelection) { return json; }

    let newNode: BlockContent;
    switch (mediaType) {
      case "audio":
        newNode = generateNode(mediaType, {
          uri: currentDocument?.audios?.[0],
          source: "local",
        });
        break;
      case "image":
        newNode = generateNode(mediaType, {
          uri: currentDocument?.images?.[0],
        });
        break;
      case "video":
        newNode = generateNode(mediaType, {
          uri: currentDocument?.media_assets?.[0]?.media_key,
          source: "reeldx",
        });
        break;
    }

    newUid = newNode.uid;

    return insertAfterNodeByUIDAtSectionLevel(json, currentSelection.uid, newNode);
  });

  return newUid;
}
